import { EstadoHorario, Problema, TabKey } from "./interfaces";

/** Textos de Horarios (Horarios Claros). Código en inglés, pantalla en español, Title Case en botones, pestañas y chips. */
const S = {
	title: "Horarios",
	ocupacion: "Ocupación de Aulas",
	nuevo: "Nuevo Horario",
	nuevoCorto: "Nuevo",
	buscar: "Buscar curso, maestra, código",
	vacio: "No hay horarios que coincidan.",
	cargando: "Cargando",
	errorLista: "La lista de horarios no pudo cargarse.",
	tabs: { enCurso: "En Curso", porEmpezar: "Por Empezar", terminados: "Terminados", todos: "Todos", revisar: "Revisar" } as Record<TabKey, string>,
	filtros: { curso: "Curso", modulo: "Módulo", maestra: "Maestra", aula: "Aula", dia: "Día", periodo: "Periodo", kit: "Kit Pendiente", limpiar: "Limpiar" },
	col: { curso: "Curso", periodo: "Periodo", horario: "Horario", aulaMaestra: "Aula y Maestra", fechas: "Fechas", alumnas: "Alumnas", estado: "Estado" },
	sinMaestra: "Sin Maestra",
	sinPeriodo: "Sin Periodo",
	sinSesiones: "Sin Horas",
	sinAula: "Sin Aula",
	estado: { enCurso: "En Curso", porEmpezar: "Por Empezar", terminado: "Terminado", fusionado: "Fusionado", nuncaComenzo: "Nunca Comenzó" } as Record<EstadoHorario, string>,
	problema: {
		nombreDistinto: "Nombre Distinto",
		fueraDeHorario: "Fuera de Horario",
		muyLarga: "Más de 4 h",
		aulaChocada: "Aula Chocada",
		maestraChocada: "Maestra Chocada",
		sinAlumnas: "Sin Alumnas",
		fechaRara: "Fecha Rara",
		sinSesiones: "Sin Sesiones"
	} as Record<Problema, string>,
	dias: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábados", "Domingos"],
	diasCortos: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sá", "Do"],
	menu: { actualizaciones: "Actualizaciones", actualizarMatricula: "Actualizar Matrícula", pasarLista: "Pasar Lista", borrar: "Borrar", ver: "Ver" },
	// Ventana del horario
	editar: "Editar",
	pasarLista: "Pasar Lista",
	actualizaciones: "Actualizaciones",
	actualizarMatricula: "Actualizar Matrícula",
	borrar: "Borrar",
	cerrar: "Cerrar",
	cancelar: "Cancelar",
	datos: { aula: "Aula", maestra: "Maestra", fechas: "Fechas", alumnas: "Alumnas", periodo: "Periodo", mensualidad: "Mensualidad", codigo: "Código", estado: "Estado" },
	vTabs: { alumnas: "Alumnas", sesiones: "Sesiones y Asuetos", precios: "Precios", historial: "Historial" },
	historia: {
		creado: "Creado", por: "por", ultimaLista: "Última lista", asistencia: "Asistencia",
		kits: (n: number) => (n === 1 ? "1 con kit pendiente" : `${n} con kit pendiente`)
	},
	alumna: { nombre: "Alumna", estado: "Estado", saldo: "Saldo", sinAlumnas: "Sin alumnas." },
	sesiones: { clase: "Clase", fecha: "Fecha", hora: "Hora", lista: "Lista", sin: "Sin sesiones." },
	precios: { sin: "Sin precios." },
	confirmarBorrar: (nombre: string) => `¿Borrar el horario ${nombre}?`,
	borrarError: "El horario no pudo borrarse. Asegúrese de que ninguna otra información dependa de él.",
	borrarSoloSinAlumnas: "Solo se puede borrar un horario sin alumnas.",
	fichaError: "La ficha del horario no pudo cargarse.",
	// Cambiar Hora (fase 2)
	ch: {
		titulo: "Cambiar Hora", usarNombre: "Usar Hora del Nombre", usarClases: "Usar Hora de las Clases", distinto: "El Nombre y las Clases Dicen Horas Distintas",
		nombreDice: "El nombre dice", clasesEstan: "Las clases están", nombreQueda: "El nombre quedará", confirmar: "Confirmar", confirmarChoque: "Confirmar con Choque",
		antes: "Hora Actual", despues: "Hora Nueva", nombreNuevo: "Nombre Nuevo", fin: "Fin", motivo: "Motivo", motivoChoque: "Motivo del Choque", dia: "Día", entrada: "Entrada", salida: "Salida",
		verClases: "Ver Clases", ocultarClases: "Ocultar Clases", colClase: "Clase", colAntes: "Antes", colDespues: "Después", colFecha: "Fecha", colMotivo: "Motivo",
		seMueven: (n: number) => (n === 1 ? "1 Clase Se Mueve" : `${n} Clases Se Mueven`), seQuedan: (n: number) => (n === 1 ? "1 Se Queda" : `${n} Se Quedan`),
		yaPasaron: (n: number) => (n === 1 ? "1 Ya Pasó" : `${n} Ya Pasaron`),
		cargando: "Calculando", error: "No se pudo calcular el cambio.", errorGuardar: "No se pudo cambiar la hora.", errorNombre: "No se pudo rehacer el nombre.", choqueForzado: "Se guardará con el choque."
	},
	// Ocupación
	oc: { titulo: "Ocupación de Aulas", dia: "Día", edificio: "Edificio", todos: "Todos", aula: "Aula", libre: "Libre", sin: "No hay aulas en este edificio.", error: "La ocupación no pudo cargarse.", crearAqui: "Nuevo Horario Aquí" }
};

export default S;
